import { SVGProps } from "react";

export const TickIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg width={props.width || "10"} height={props.height || "8"} viewBox="0 0 10 8" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M1 3.88721L3.88382 7L9 1" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
);
